function load(component) {
    return () => import(`@/components/${component}.vue`);
}
export default {
    path: "/purchase",
    component: load("dashboard"),
    children: [
        {
            path: "index",
            name: "purchase-order",
            component: load("purchase/Order"),
            meta: {
                parent: "purchase",
                child: "order",
                deal: false
            }
        },
        {
            path: "create",
            name: "create-order",
            component: load("purchase/CreateOrder"),
            meta: {
                parent: "purchase",
                child: "order",
                deal: true
            }
        },
        {
            path: "number/:id",
            name: "order-number",
            component: load("purchase/OrderNumber"),
            meta: {
                parent: "purchase",
                child: "order",
                deal: false
            }
        },
        {
            path: "outsource",
            name: "outsource-order",
            component: load("purchase/OutSourceOrder"),
            meta: {
                parent: "purchase",
                child: "order",
                deal: false
            }
        },
        {
            path: "outsource-info/:id",
            name: "outsource-info",
            component: load("purchase/OutSourceInfo"),
            meta: {
                parent: "purchase",
                child: "order",
                deal: false
            }
        },
        {
            path: "service",
            name: "service-order",
            component: load("purchase/ServiceOrder"),
            meta: {
                parent: "purchase",
                child: "order",
                deal: false
            }
        },
        {
            path: "create-service",
            name: "create-service",
            component: load("purchase/CreateServiceOrder"),
            meta: {
                parent: "purchase",
                child: "order",
                deal: true
            }
        },
        {
            path: "service-number/:id",
            name: "service-number",
            component: load("purchase/ServiceNumber"),
            meta: {
                parent: "purchase",
                child: "order",
                deal: false
            }
        },
        {
            path: "goods-content",
            name: "goods-content",
            component: load("purchase/GoodsContent"),
            meta: {
                parent: "purchase",
                child: "content",
                deal: false
            }
        },
        {
            path: "outsource-content",
            name: "outsource-content",
            component: load("purchase/OutSourceContent"),
            meta: {
                parent: "purchase",
                child: "content",
                deal: true
            }
        },
        {
            path: "service-content",
            name: "service-content",
            component: load("purchase/ServiceContent"),
            meta: {
                parent: "purchase",
                child: "content",
                deal: true
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/router/purchase.js